var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fas fa-spinner fa-pulse text-primary"}),_vm._v(" "),_c('span',{staticClass:"ms-2"},[_vm._v("Caricamento in corso...")])])
}]

export { render, staticRenderFns }